/**
 * Security Entitlements Hook
 *
 * Fetches SOC/Compliance/Protect entitlements for the current tenant.
 * Defaults to all enabled during loading (prevents flash of upsell).
 */

import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

export interface SecurityEntitlements {
  soc_enabled: boolean;
  soc_tier: 'essentials' | 'complete';
  compliance_enabled: boolean;
  compliance_tier: 'essentials' | 'complete';
  compliance_frameworks_limit: number;
  protect_enabled: boolean;
  protect_tier: 'essentials' | 'complete';
}

const DEFAULTS: SecurityEntitlements = {
  soc_enabled: true,
  soc_tier: 'essentials',
  compliance_enabled: true,
  compliance_tier: 'essentials',
  compliance_frameworks_limit: 3,
  protect_enabled: true,
  protect_tier: 'essentials',
};

export function useEntitlements() {
  const [entitlements, setEntitlements] = useState<SecurityEntitlements>(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<SecurityEntitlements>('/auth/entitlements')
      .then(setEntitlements)
      .catch(() => {
        // On error, default to all enabled (backwards compat)
        setEntitlements(DEFAULTS);
      })
      .finally(() => setLoading(false));
  }, []);

  return { entitlements, loading };
}
